import {
    UPDATE_ITEM_INDEX,
    UPDATE_MODAL_STATUS,
    CLICK_BUTTON,
    CLICK_INTRO_START_BUTTON,
} from '../actions/Modal';
import { compStatusTypes } from '../Constants';

// 팝업에서 생성되는 이벤트 처리는 여기서.
export default class modalMiddleware {
    constructor(emitter) {
        this.emitter = emitter;
    }

    get modalEvent() {
        return (store) => (next) => (action) => {
            const result = next(action);
            switch (action.type) {
                case UPDATE_ITEM_INDEX: {
                    break;
                }
                case UPDATE_MODAL_STATUS: {
                    if (action.data === compStatusTypes.ENABLED) {
                        this.emitter.emit('show');
                    }
                    if (action.data === compStatusTypes.HIDDEN) {
                        this.emitter.emit('hide');
                    }
                    break;
                }
                case CLICK_INTRO_START_BUTTON: {
                    this.emitter.emit('click', 'start');
                    this.emitter.emit('hide');
                    break;
                }
                case CLICK_BUTTON: {
                    const { event = '', data } = action.data;
                    this.emitter.emit('click', event, data);
                    this.emitter.emit('hide');
                    break;
                }
                default: {
                    break;
                }
            }

            return result;
        };
    }
}



// WEBPACK FOOTER //
// ./middleware/Modal.js